import { isNil, omitBy } from 'lodash';

import { _QueryResources } from '@/lib/datx-jsonapi-react';
import { LectureTags } from '@/resources/LectureTags';

export const queryAllLectureTags = (filters = {}): _QueryResources<LectureTags> => {
  return [
    LectureTags,
    {
      filter: omitBy(
        {
          filters,
        },
        isNil
      ),
      // sort,
      loadAll: true,
    },
  ];
};
